import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Header from '../Header/Header';
import { CartContext } from '../Cart/CartContext';
import { useContext } from 'react';
import Footer from '../Footer/Footer';
import { WishlistContext } from '../Wishlist/WishlistContext';
import { FcBookmark } from 'react-icons/fc';
import { FaRegBookmark } from 'react-icons/fa';
import { IoChevronUp, IoChevronDown } from "react-icons/io5";

import ReactCountryFlag from "react-country-flag";
import { countryCodeMap } from "../countryMap/countryMap";

const ProductDetails = () => {
    const { id } = useParams();
    const { cartItems, addToCart, removeFromCart, increaseQuantity, decreaseQuantity } = useContext(CartContext);

    const { addToWishlist } = useContext(WishlistContext);
    const [product, setProduct] = useState(null);
    const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [zoom, setZoom] = useState(false);
    const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
    const imgRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


    const [wishlist, setWishlist] = useState({}); // mapping key -> true


    const [detailsVisible, setDetailsVisible] = useState(false);
    const [expanded, setExpanded] = useState(null);

    const toggleDetails = () => {
        setDetailsVisible(!detailsVisible);
    };

    const toggleSection = (section) => {
        setExpanded(expanded === section ? null : section);
    };

    const sections = ["Ingredients", "Nutritional Facts", "Features", "Other Product Info"];






    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('userData'));
        if (!user?.id) return;

        const fetchWishlist = () => {
            axios
                .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
                .then((res) => {
                    const wishMap = {};
                    res.data.forEach((item) => {
                        const key = `${item.productId}_${item.variantId}`;
                        wishMap[key] = true;
                    });
                    setWishlist(wishMap);
                })
                .catch((err) => console.error('Error fetching wishlist:', err));
        };

        // Initial fetch
        fetchWishlist();

        // Fetch every 1 second
        const intervalId = setInterval(fetchWishlist, 1000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId);
    }, []);

    // Listen for screen resize
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        axios.get(`https://api.glocart.in/pages/api/get/productdetailsview/${id}`)
            .then(res => {
                setProduct(res.data);

            })
            .catch(err => {
                console.log('Failed to load product data.');

            });
    }, [id]);


    if (!product || !product.variants || product.variants.length === 0) return <div>No product details available.</div>;

    const { name, brand, image_1, image_2, image_3, image_4, variants, super_category, long_description, short_description, recipe, ingredients, features, nutritional_facts } = product;

    const images = [image_1, image_2, image_3, image_4].filter(Boolean);
    const variant = variants[selectedVariantIndex];
    const discountPrice = variant.price
        ? (variant.price - (variant.price * variant.discount) / 100).toFixed(2)
        : 'N/A';

    const handleMouseMove = e => {
        const rect = imgRef.current.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        setZoomPos({ x, y });
    };

    const currentCartItem = cartItems.find(item =>
        item.variantId === variant.id && item.productId === product.id
    );

    const currentQuantity = currentCartItem ? currentCartItem.quantity : 0;




    return (
        <>
            <Header />
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", padding: 16, maxWidth: 1200, margin: 'auto', gap: 24 }}>
                {/* Thumbnails */}
                <div style={{ display: 'flex', flexDirection: isMobile ? 'row' : 'column', gap: 12, overflowX: isMobile ? 'auto' : 'unset', paddingBottom: isMobile ? 10 : 0 }}>
                    {images.map((img, idx) => (
                        <div key={idx} onClick={() => { setSelectedImageIndex(idx); setZoom(false); }}
                            style={{
                                border: idx === selectedImageIndex ? '2px solid #4CAF50' : '1px solid #ddd',
                                padding: 4,
                                borderRadius: 6,
                                cursor: 'pointer',
                                width: 80,
                                height: 80,
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: idx === selectedImageIndex ? '0 0 8px #4CAF50' : 'none',
                                flexShrink: 0
                            }}
                        >
                            <img src={img} alt={`Thumbnail ${idx + 1}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        </div>
                    ))}
                </div>

                {/* Main Image */}
                <div
                    style={{
                        flex: isMobile ? '0 0 100%' : '0 0 450px',
                        border: '1px solid #ddd',
                        borderRadius: 8,
                        padding: 16,
                        background: '#fff',
                        boxShadow: '0 4px 8px rgb(0 0 0 / 0.1)',
                        position: 'relative',
                        cursor: zoom ? 'zoom-out' : 'zoom-in',
                        overflow: 'hidden',
                        marginTop: isMobile ? 16 : 0
                    }}
                    onMouseEnter={() => setZoom(true)}
                    onMouseLeave={() => setZoom(false)}
                    onMouseMove={handleMouseMove}
                >
                    <img ref={imgRef} src={images[selectedImageIndex]} alt={`Product Image ${selectedImageIndex + 1}`} style={{ maxWidth: '100%', maxHeight: 380, objectFit: 'contain', borderRadius: 8, transition: 'transform 0.3s ease', transform: zoom ? 'scale(2)' : 'scale(1)', transformOrigin: `${zoomPos.x}% ${zoomPos.y}%` }} />
                </div>

                {/* Info Section */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 14, marginTop: isMobile ? 24 : 0 }}>
                
                    <p style={{ fontSize: 11, color: '#000000', marginBottom: 4, display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <ReactCountryFlag
                            countryCode={countryCodeMap[super_category]}
                            svg
                            style={{ width: '18px', height: '18px' }}
                        />
                        {super_category}
                    </p>
                    <h1 style={{ fontWeight: 700, fontSize: 24, margin: 0 }}>{name}</h1>
                        <div style={{ color: '#888', fontWeight: 600, fontSize: 14 }}>{brand}</div>
                    <p className='mb-0' style={{ color: '#444', fontSize: 16 }}>
                        <span style={{ textDecoration: 'line-through', color: '#999' }}>
                            MRP: ₹{variant.price}
                        </span>
                    </p>
                    <div className='mb-0' style={{ fontSize: 20, fontWeight: 700, color: '#212121' }}>
                        {variant.discount > 0 ? (
                            <>
                                <span>₹{discountPrice}</span>
                                <span style={{ textDecoration: 'line-through', color: '#999', fontWeight: 400, fontSize: 16, marginLeft: 8 }}>
                                    ₹{variant.price}
                                </span>
                                <span style={{ color: '#388E3C', fontWeight: 600, fontSize: 14, marginLeft: 10 }}>
                                    {variant.discount}% OFF
                                </span>
                            </>
                        ) : (
                            <span>₹{variant.price}</span>
                        )}
                    </div>
                    <p className='mb-0' style={{ color: '#444', fontSize: 16 }}>
                        <span style={{ color: '#388E3C', fontWeight: 600, fontSize: 14 }}>
                            You have Save {variant.discount}% OFF
                        </span>
                    </p>
                    <p className='mb-0'><span style={{ color: '#888', fontWeight: 600, fontSize: 14 }}>(inclusive of all taxes)</span></p>
                    <div style={{ marginTop: 30, display: 'flex', gap: 14, flexDirection: isMobile ? 'column' : 'row' }}>
                        {currentQuantity === 0 ? (
                            <button
                                onClick={() => {
                                    addToCart({
                                        productId: product.id,
                                        variantId: variant.id,
                                        name,
                                        image: images[selectedImageIndex],
                                        price: parseFloat(discountPrice),
                                        originalPrice: variant.price,
                                        quantity: 1,
                                        type: product.type || "default",
                                        variant,
                                    }, 1);
                                }}
                                style={{ padding: '10px', border: '1px solid #f44336', background: '#fff', color: '#f44336', width: isMobile ? '100%' : 'auto' }}
                            >
                                Add to Cart
                            </button>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#D40000', overflow: 'hidden', width: isMobile ? '100%' : 'auto' }}>
                                <button onClick={() => currentQuantity === 1 ? removeFromCart(product.id, variant.id) : decreaseQuantity(product.id, variant.id)} style={{ width: 40, background: '#d32f2f', color: '#fff', border: 'none', fontSize: 22, fontWeight: 'bold', cursor: 'pointer' }}>−</button>
                                <div style={{ width: 60, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontSize: 18, fontWeight: 'bold' }}>{currentQuantity}</div>
                                <button
                                    onClick={() => {
                                        console.log("Current Quantity:", currentQuantity);
                                        console.log("Variant Stock:", variant.stock);
                                        if (currentQuantity < variant.stock) {
                                            console.log("Increasing quantity...");
                                            increaseQuantity(product.id, variant.id);
                                        } else {
                                            console.warn("Cannot increase. Stock limit reached.");
                                            alert('No more stock available.');
                                        }
                                    }}

                                    disabled={currentQuantity >= variant.stock}
                                    style={{
                                        width: 40,
                                        background: currentQuantity >= variant.stock ? '#ccc' : '#d32f2f',
                                        color: '#fff',
                                        border: 'none',
                                        fontSize: 22,
                                        fontWeight: 'bold',
                                        cursor: currentQuantity >= variant.stock ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    +
                                </button>

                            </div>
                        )}
                        {(() => {
                            const key = `${product.id}_${variant?.id}`;
                            const isWishlisted = wishlist[key];
                            return (
                                <button
                                    style={{
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        fontWeight: 600,
                                        fontSize: 16,
                                        cursor: 'pointer',
                                        backgroundColor: '#fff',
                                        boxShadow: '0 2px 6px rgb(0 0 0 / 0.1)',
                                        width: isMobile ? '100%' : 'auto'
                                    }}

                                    //  onClick={() => addToWishlist(product, variant)}
                                    onClick={async () => {
                                        try {
                                            await addToWishlist(product, variant); // call context function

                                            if (isWishlisted) {
                                                alert(`${product.name} removed from wishlist!`);
                                            } else {
                                                alert(`${product.name} added to wishlist!`);
                                            }
                                        } catch (err) {
                                            alert("Could not update wishlist. Please try again.");
                                        }
                                    }}


                                >
                                    {isWishlisted ? (
                                        <FcBookmark size={22} />     // filled icon
                                    ) : (
                                        <FaRegBookmark size={22} />  // empty icon
                                    )}
                                    Save for later
                                </button>
                            )
                        })()}
                    </div>

                    {/* Pack Sizes */}
                    <div style={{ marginTop: 20 }}>
                        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10 }}>Pack sizes</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {variants.map((v, i) => {
                                const priceAfterDiscount = v.price - (v.price * v.discount) / 100;
                                return (
                                    <div
                                        key={v.id}
                                        onClick={() => {
                                            setSelectedVariantIndex(i);
                                            setSelectedImageIndex(0);
                                            setZoom(false);
                                        }}
                                        style={{
                                            border: i === selectedVariantIndex ? '2px solid #4CAF50' : '1px solid #ddd',
                                            borderRadius: 8,
                                            padding: 14,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            backgroundColor: i === selectedVariantIndex ? '#E8F5E9' : '#fff',
                                            boxShadow: i === selectedVariantIndex ? '0 0 6px #4CAF50' : 'none'
                                        }}
                                    >
                                        <div style={{ fontWeight: 600 }}>
                                            {v.unit_value} {v.unit}
                                            <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>
                                                {/* (Approx. {v.unit_value * 3} - {v.unit_value * 4} pcs) */}
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <div style={{ fontWeight: 700, fontSize: 18 }}>₹{priceAfterDiscount.toFixed(2)}</div>
                                            {v.discount > 0 && (
                                                <div style={{ fontSize: 12, color: '#388E3C', fontWeight: 600 }}>
                                                    {v.discount}% OFF
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Highlights */}
                    <div style={{ marginTop: 30 }}>
                        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10 }}>Highlights</div>
                        <span style={{ display: 'inline-block', backgroundColor: '#f0f0f0', padding: '6px 12px', borderRadius: 20, fontSize: 14, color: '#444' }}>
                            Good Product
                        </span>
                    </div>
                </div>


            </div>

            {/* More Info */}
            {/* <div style={{ textAlign: 'center', margin: '40px 0' }}>
                <hr style={{ border: 'none', borderTop: '1px solid #ccc', marginBottom: 8 }} />
                <span style={{ color: '#888', fontSize: 14 }}>More Product Information</span>
                <hr style={{ border: 'none', borderTop: '1px solid #ccc', marginTop: 8 }} />
            </div> */}

            {/* Long Description */}
            <div style={{ display: 'flex', flexDirection: 'column', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", padding: 16, maxWidth: 1200, margin: 'auto' }}>
                <div style={{ marginTop: 20, padding: '24px', backgroundColor: '#f9f9f9', border: '1px solid #ddd', fontSize: 15, lineHeight: 1.7, color: '#333', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                    {/* <h2 style={{ fontSize: 20, marginBottom: 16, color: '#222', fontWeight: 700 }}>About the Product</h2> */}
                    <div
                        onClick={toggleDetails}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#E6F0FF",
                            padding: "10px",
                            margin: "10px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            textAlign: 'center',
                        }}
                    >
                        <span
                            style={{
                                color: "#007bff",
                                fontWeight: "600",
                                fontSize: "14px",
                                marginRight: "5px"
                            }}
                        >
                            {detailsVisible ? "Hide product details" : "View product details"}
                        </span>

                        {detailsVisible ? (
                            <IoChevronUp size={18} color="#007bff" />
                        ) : (
                            <IoChevronDown size={18} color="#007bff" />
                        )}
                    </div>
                    {/* <hr />
                    <div dangerouslySetInnerHTML={{ __html: long_description }} /> */}

                    {detailsVisible && (
                        <div
                            style={{
                                marginTop: "10px",
                                backgroundColor: "#fff",
                                padding: "10px 0",
                                marginLeft: "10px",
                                marginRight: "10px",
                                borderRadius: "5px",
                                border: "1px solid lightgray",

                            }}
                        >

                            {/* About Section */}
                            <div
                                onClick={() => toggleSection("about")}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    cursor: "pointer",
                                    backgroundColor: expanded === "about" ? "#E6F0FF" : "white"
                                }}
                            >
                                <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                    About the Product
                                </span>

                                {expanded === "about" ? <IoChevronUp /> : <IoChevronDown />}
                            </div>

                            {expanded === "about" && (
                                <div style={{ padding: "0 15px 15px 15px" }}>
                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                        {long_description}  </p>

                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px", marginTop: "4px" }}>
                                        {short_description}    </p>
                                </div>
                            )}

                            <div
                                onClick={() => toggleSection("Ingredients")}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    cursor: "pointer",
                                    backgroundColor: expanded === "Ingredients" ? "#E6F0FF" : "white"
                                }}
                            >
                                <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                    Ingredients
                                </span>

                                {expanded === "Ingredients" ? <IoChevronUp /> : <IoChevronDown />}
                            </div>

                            {expanded === "Ingredients" && (
                                <div style={{ padding: "0 15px 15px 15px" }}>
                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                        {ingredients}                   </p>


                                </div>
                            )}




                            <div
                                onClick={() => toggleSection("recipe")}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    cursor: "pointer",
                                    backgroundColor: expanded === "recipe" ? "#E6F0FF" : "white"
                                }}
                            >
                                <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                    recipe
                                </span>

                                {expanded === "recipe" ? <IoChevronUp /> : <IoChevronDown />}
                            </div>

                            {expanded === "recipe" && (
                                <div style={{ padding: "0 15px 15px 15px" }}>
                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                        {recipe}                   </p>


                                </div>
                            )}




                            <div
                                onClick={() => toggleSection("features")}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    cursor: "pointer",
                                    backgroundColor: expanded === "features" ? "#E6F0FF" : "white"
                                }}
                            >
                                <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                    features
                                </span>

                                {expanded === "features" ? <IoChevronUp /> : <IoChevronDown />}
                            </div>

                            {expanded === "features" && (
                                <div style={{ padding: "0 15px 15px 15px" }}>
                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                        {features}                   </p>


                                </div>
                            )}



                            <div
                                onClick={() => toggleSection("nutritional_facts")}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    cursor: "pointer",
                                    backgroundColor: expanded === "nutritional_facts" ? "#E6F0FF" : "white"
                                }}
                            >
                                <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                    nutritional_facts
                                </span>

                                {expanded === "nutritional_facts" ? <IoChevronUp /> : <IoChevronDown />}
                            </div>

                            {expanded === "nutritional_facts" && (
                                <div style={{ padding: "0 15px 15px 15px" }}>
                                    <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                        {nutritional_facts}                   </p>


                                </div>
                            )}

                            {/* Other Sections */}
                            {/* {sections.map((section) => (
                                <div key={section}>
                                    <div
                                        onClick={() => toggleSection(section)}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "15px",
                                            cursor: "pointer",
                                            backgroundColor: expanded === section ? "#E6F0FF" : "white"
                                        }}
                                    >
                                        <span style={{ fontSize: "15px", fontWeight: "600", color: "#000" }}>
                                            {section}
                                        </span>

                                        {expanded === section ? <IoChevronUp /> : <IoChevronDown />}
                                    </div>

                                    {expanded === section && (
                                        <div style={{ padding: "0 15px 15px 15px" }}>
                                            <p style={{ fontSize: "14px", color: "#333", lineHeight: "20px" }}>
                                                Information about {section.toLowerCase()} will appear here.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))} */}
                        </div>
                    )}
                </div>
            </div>


            <Footer />
        </>
    );
};

export default ProductDetails;
